import { fieldTypes as customFieldTypes } from "conf/field"

const formFieldTypes = [
    { val: "text", label: "Text" },
    { val: "email", label: "Adresă e-mail" },
    { val: "textarea", label: "Text lung" },
    { val: "captcha", label: "Captcha" },
    { val: "submit", label: "Trimite" },
]

const fieldSettings = [
    {
        name: "_nodel",
        type: "bool",
        label: "Nu se poate șterge",
        widget: "toggle",
        require: "admin",
    },
    {
        name: "_hidden",
        type: "bool",
        label: "Ascuns",
        widget: "toggle",
        require: "admin",
    },
    { name: "_label", type: "text", label: "Etichetă" },
    { name: "id", type: "text", label: "CSS ID" },
    { name: "_class", type: "text", label: "Clasa CSS" },
    { name: "_visibility", type: "bool", label: "CSS: Marchează vizibilitatea" },
    { name: "_renderer", type: "text", label: "Renderer", require: "admin" },
    { name: "region", type: "text", label: "Regiune" },
    { name: "_inner", type: "bool", label: "Container interior" },
    { name: "_inner2", type: "bool", label: "Container interior dublu" },
    //{ name: "_nowrap", type: "bool", label: "Fără container interior" },
]

let fieldTypes = {
    text: {
        name: "Text simplu",
        type: "text",
        getLabel: value => value,
        settings: [
            { name: "linkTo", type: "text", label: "Legătură către" },
            { name: "iconBefore", type: "ricon", label: "Iconiță în față" },
            { name: "iconAfter", type: "ricon", label: "Iconiță în spate" },
        ],
    },
    int: {
        name: "Număr întreg",
        type: "int",
        getLabel: value => value,
    },
    number: {
        name: "Număr",
        type: "number",
        getLabel: value => value,
    },
    html: {
        name: "HTML",
        type: "html",
        getLabel: value =>
            value
                ? typeof value === "string"
                    ? value
                    : value.raw && value.raw.blocks && value.raw.blocks.length > 0
                    ? value.raw.blocks[0].text
                    : ""
                : "",
    },
    date: {
        name: "Data",
        type: "date",
        setValue: value => {
            if (value === "now") return new Date()
            return value
        },
        settings: [{ name: "showTime", type: "bool", label: "Data și Ora", widget: "toggle" }],
    },
    img: {
        name: "Imagine",
        type: "img",
        getLabel: value => (value && value.length > 0 ? value[0].name : ""),
        settings: [
            { name: "_carousel", type: "bool", label: "Carusel", widget: "toggle" },
            { name: "bg", type: "bool", label: "Fundal", require: "admin" },
            {
                name: "wrap",
                type: "bool",
                label: "Containere individuale",
                require: "admin",
            },
            {
                name: "proportional",
                type: "bool",
                label: "Proporțional",
                require: "admin",
            },
        ],
    },
    vid: {
        name: "Video",
        type: "vid",
        settings: [
            {
                name: "playsInline",
                type: "bool",
                label: "PlaysInline",
                default: true,
                widget: "toggle",
            },
            { name: "controls", type: "bool", label: "Controls", default: true, widget: "toggle" },
            { name: "muted", type: "bool", label: "Muted", widget: "toggle" },
            { name: "autoPlay", type: "bool", label: "AutoPlay", widget: "toggle" },
            { name: "loop", type: "bool", label: "Loop", widget: "toggle" },
        ],
        getLabel: value =>
            value ? (value.length === 1 ? value[0].name : `${value.length} fișiere`) : "",
    },
    video: {
        name: "Link Video",
        type: "video",
        getLabel: value => value,
    },
    doc: {
        name: "Doc",
        type: "doc",
        getLabel: value => value,
    },
    bool: {
        name: "Bool",
        type: "bool",
        getLabel: value => value,
    },
    class: {
        name: "Clasă",
        type: "class",
        getLabel: value => value,
    },
    radio: {
        name: "Butoane radio",
        type: "radio",
        getLabel: () => "",
    },
    select: {
        name: "Selector",
        type: "select",
        getLabel: () => "",
    },
    list: {
        name: "Listă",
        type: "list",
        getLabel: () => "",
    },
    obj: {
        name: "Obiect",
        type: "obj",
        getLabel: () => "",
    },
    custom: {
        name: "Personalizat",
        type: "custom",
        getLabel: () => "",
    },
    ref: {
        name: "Reference",
        type: "ref",
        getLabel: () => "",
    },
    ricon: {
        name: "Remote Icon",
        type: "obj",
        fields: [
            { name: "icon", type: "text", label: "Nume" },
            { name: "size", type: "int", label: "Mărime" },
        ],
        getLabel: () => "",
        renderer: "RemoteIcon",
        _nowrap: true,
    },
    form: {
        name: "Formular",
        type: "obj",
        getLabel: () => "",
        isBlock: true,
        renderer: "Form",
        _nowrap: true,
        fields: [
            { name: "name", type: "text", label: "Nume", fullWidth: true },
            { name: "sendMail", type: "bool", label: "Trimite mesaj" },
            //{ name: "address", type: "text", label: "Adresa", fullWidth: true },
            //{ name: "subject", type: "text", label: "Subiect", fullWidth: true },
        ],
        states: [
            { val: "open", label: "Deschis" },
            { val: "sending", label: "Se trimite" },
            { val: "sent", label: "Trimis" },
        ],
    },
    "form-field": {
        name: "Rubrică Formular",
        type: "obj",
        getLabel: () => "",
        fields: [
            { name: "label", type: "text", label: "Etichetă", fullWidth: true },
            {
                name: "fieldType",
                type: "select",
                label: "Tip",
                values: formFieldTypes,
            },
            { name: "mandatory", type: "bool", label: "Obligatoriu" },
            //{ name: "sendTo", type: "bool", label: "Trimite mesaj" },
        ],
        renderer: "FormField",
        _nowrap: true,
        /*conditional: [
            [
                v => v.fieldType === "email" && v._e && v._e.sendTo && v._e.sendTo._hidden,
                v => ({
                    ...v,
                    _e: {
                        ...v._e,
                        sendTo: { ...(v._e && v._e.sendTo ? v._e.sendTo : {}), _hidden: false },
                    },
                }),
            ],
            [
                v => v.fieldType !== "email",
                v => ({
                    ...v,
                    _e: {
                        ...(v._e || {}),
                        sendTo: {
                            ...(v._e && v._e.sendTo ? v._e.sendTo : {}),
                            _hidden: true,
                        },
                    },
                }),
            ],
        ],*/
    },

    view: {
        name: "Vizualizare",
        type: "obj",
        fields: [
            { name: "title", type: "text", label: "Titlu" },
            { name: "view", type: "text", label: "Vizualizare" },
            { name: "collection", type: "text", label: "Collection" },
            { name: "query", type: "text", label: "Interogare" },
            { name: "projection", type: "text", label: "Proiecție" },
            { name: "sort", type: "text", label: "Ordonare" },
            { name: "limit", type: "text", label: "Limită" },
            { name: "display", type: "text", label: "Afișare" },
            { name: "pageSize", type: "text", label: "Pagină" },
            { name: "moreLink", type: "href", label: "Legătură 'Mai mult...'" },
            { name: "moreText", type: "text", label: "Text 'Mai mult...'" },
        ],
        //isEmpty: value => !value || !value.path || value.path === "",
        _nowrap: true,
        renderer: "View",
    },
    seo: {
        name: "SEO",
        type: "obj",
        fields: [
            { name: "title", type: "text", label: "Titlu", fullWidth: true },
            {
                name: "description",
                type: "text",
                label: "Descriere",
                fullWidth: true,
                multiline: true,
                rows: 3,
            },
            { name: "image", type: "img", label: "Imagine" },
        ],
        widgetProps: { nolabel: true },
    },
}
Object.keys(fieldTypes).forEach(type => {
    fieldTypes[type].typeName = type
    if (type === fieldTypes[type].type) fieldTypes[type].primitive = true
})
Object.keys(customFieldTypes).forEach(type => {
    if (fieldTypes[type])
        fieldTypes[type] = Object.assign({}, fieldTypes[type], customFieldTypes[type])
    else fieldTypes[type] = { ...customFieldTypes[type], typeName: type }
})
Object.keys(fieldTypes).forEach(type => {
    if (fieldTypes[type].fields) {
        //console.log(type, fieldTypes[type])
        fieldTypes[type].fields = fieldTypes[type].fields.map(f =>
            fieldTypes[f.type] ? { ...fieldTypes[f.type], ...f } : f
        )
    }
    fieldTypes[type].settings = [...fieldSettings, ...(fieldTypes[type].settings || [])]
})
//console.log(fieldTypes)
export { fieldTypes }
